// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"17":"ViewSale","94":"Login","220":"create-debtor","351":"float","472":"settings","693":"salesRecords","930":"setup"}[chunkId] || chunkId) + "-legacy." + {"17":"d923bcd2","94":"d42f287f","220":"8faae07b","243":"c39a19e1","351":"dbda156f","472":"fe7ac4be","693":"3875eb97","930":"73f0654a"}[chunkId] + ".js";
};